module.exports = __webpack_public_path__ + "img/relevadores_y_temporizadores.36742edc.jpg";